// extracted by mini-css-extract-plugin
export default {"toTopBox":"index_toTopBox_ypd5n","suggest":"index_suggest_Phv9O","backTop":"index_backTop_53Wjj"};